export default Object.freeze({
    PRIMARIA: 'PRIMARIA',
    SECUNDARIA: 'SECUNDARIA',
    PREPARATORIA: 'PREPARATORIA',
    LICENCIATURA: 'LICENCIATURA',
    POSGRADO: 'POSGRADO'
})
